import type { FeatureGates, FeatureGateValue } from "@gamedev-web/gamedev-sdk-core";
import { createAction } from "./internal/platformActionCreators";
import { Scope } from "./scopes";

export enum ExperimentActions {
  SET_FEATURE_GATE_OVERRIDES = "@experiments/SET_FEATURE_GATE_OVERRIDES",
  SET_EXPERIMENT_DATA = "@experiments/SET_EXPERIMENT_DATA",
}

export const experimentActions = {
  setFeatureGateOverrides: createAction(
    ExperimentActions.SET_FEATURE_GATE_OVERRIDES,
    Scope.Experiments,
    (featureGates: ReadonlyDictionary<FeatureGateValue>) => ({ featureGates })
  ),
  setExperimentData: createAction(
    ExperimentActions.SET_EXPERIMENT_DATA,
    Scope.Experiments,
    (environmentFeatureGates: FeatureGates, urlQueryFeatureGates: FeatureGates) => ({
      environmentFeatureGates,
      urlQueryFeatureGates,
    })
  ),
};
